import { PublicKey } from "@solana/web3.js";
import { makeDSTProgram } from "./makeDSTProgram.js";

export function transferOperator({
  dst,
  pendingOperator,
  operator,
}: {
  dst: PublicKey;
  pendingOperator: PublicKey;
  operator: PublicKey;
}) {
  const program = makeDSTProgram();
  const result = program.methods.transferOperator().accountsPartial({
    dst,
    pendingOperator,
    operator,
  });

  return result;
}
